import { PlanWorkAssociationCoreBase } from "./plan-work-association.core.base"


export class PlanWorkAssociationCore extends PlanWorkAssociationCoreBase {

}